import styled from "@emotion/styled";
import * as React from "react";

import { SpacingToken, Switch, Text } from "@livechat/design-system-react-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: var(${SpacingToken.Spacing2});
  cursor: pointer;
`;

interface IProps {
  onClick: () => void;
  on: boolean;
}

export const DistributionToggler: React.FC<IProps> = ({ onClick, on }) => (
  <Container>
    <Text onClick={onClick}>24-hour distribution:</Text>
    <Switch size="compact" on={on} onChange={onClick} />
  </Container>
);
